import { render, staticRenderFns } from "./U18.vue?vue&type=template&id=5d256d44"
import script from "./U18.vue?vue&type=script&lang=js"
export * from "./U18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports